/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_error_passkey_name_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey name is required`)
};

const zh_hans1_settings_error_passkey_name_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通行密钥名称不能为空`)
};

const zh_hant1_settings_error_passkey_name_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請輸入通行金鑰名稱`)
};

const fr_settings_error_passkey_name_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nom du passkey est requis`)
};

const de_settings_error_passkey_name_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey-Name ist erforderlich`)
};

const ja_settings_error_passkey_name_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキー名は必須です`)
};

const ko_settings_error_passkey_name_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`패스키 이름을 입력하세요`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_error_passkey_name_required = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_error_passkey_name_required(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_error_passkey_name_required", locale)
	if (locale === "en") return en_settings_error_passkey_name_required(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_error_passkey_name_required(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_error_passkey_name_required(inputs)
	if (locale === "fr") return fr_settings_error_passkey_name_required(inputs)
	if (locale === "de") return de_settings_error_passkey_name_required(inputs)
	if (locale === "ja") return ja_settings_error_passkey_name_required(inputs)
	return ko_settings_error_passkey_name_required(inputs)
};